<template>
  <v-container class='cambiarPage'>
    <h1 class='cambiarTitle'>{{ cambiarTitle }}</h1>

    <v-card v-if='mode === "request"' width='600' class='mx-auto'>
      <v-card-title class='formTitle'>Solicitar cambio de contraseña</v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols='12' sm='8'>
              <v-text-field
                v-model='user'
                label='Nombre de usuario o correo electrónico'
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols='12' sm='4' class='text-center'>
              <v-btn
                @click='sendRequest'
                color='primary'
                :disabled='!ready'
              >Solicitar</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-card v-if='mode === "change"' width='500' class='mx-auto'>
      <v-card-title class='formTitle'>
        Introduzca su nueva contraseña
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click='switchAll($event)'
          :title='(!show.all ? "Mostrar" : "Ocultar") + " todos"'>
          <v-icon>{{ show.all ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-container>
          <v-row>
            <v-spacer></v-spacer>
            <v-col cols='10'>
              <v-text-field
                v-model='newPassword'
                label='Nueva contraseña'
                outlined
                :append-icon="show.new ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show.new ? 'text' : 'password'"
                @click:append="show.new = !show.new"
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row>
            <v-spacer></v-spacer>
            <v-col cols='10'>
              <v-text-field
                v-model='repeatPassword'
                label='Confirme su contraseña'
                outlined
                :append-icon="show.repeat ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show.repeat ? 'text' : 'password'"
                @click:append="show.repeat = !show.repeat"
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row>
            <v-spacer></v-spacer>
            <v-col cols='10' align='right'>
              <v-btn
                @click='getNewPassword'
                color='primary'
                :disabled='!ready'
              >Cambiar</v-btn>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import { ApiInit } from '@/api';
  import { consoleErrorMessage, toasterErrorMessage } from '@/utils/responseCatchMessages.js';
  import { incompleteQuery } from '@/utils/checkQuery.js';
  export default {
    data() {
      return {
        user: '',
        userId: 0,
        changePasswordToken: '',
        newPassword: '',
        repeatPassword: '',
        awaitingResponse: false,
        mode: '',
        show: {
          all: false,
          new: false,
          repeat: false,
        },
      }
    },
    computed: {
      cambiarTitle() {
        switch (this.mode) {
          case 'request':
          return 'Recuperación de la contraseña';
          case 'change':
          return 'Cambiar Contraseña';
          default: return '';
        }
      },
      request() {
        switch (this.mode) {
          case 'request':
          return {
            user: this.user,
          };

          case 'change':
          return {
            userId: this.userId,
            changePasswordToken: this.changePasswordToken,
            newPassword: this.newPassword,
            repeatPassword: this.repeatPassword,
          };

          default: return null;
        }
      },
      ready() {
        if (this.awaitingResponse) return false;
        switch (this.mode) {
          case 'request':
          if (this.user.length > 0) return true;
          return false;

          case 'change':
          if (this.newPassword.length > 0 && this.repeatPassword.length > 0) return true;
          return false;

          default: return false;
        }
      },
    },
    mounted() {
      ApiInit().then(r => this.init());
    },
    methods: {
      init() {
        const query = this.$route.query;
        const requiredParams = ['u', 'tpu'];
        if (!incompleteQuery(query, requiredParams)) {
          this.userId = query.u;
          this.changePasswordToken = query.tpu;
          this.mode = 'change';
        } else this.mode = 'request';
      },
      async sendRequest() {
        const defaultToastMessage = 'Error al solicitar el cambio de contraseña.';
        const defaultConsoleMessage = 'sendRequest error';
        try {
          this.awaitingResponse = true;
          const request = this.request;
          const response = await this.$store.dispatch('requestPasswordRecovery', {request});
          if (response === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            this.stopWait();
            return;
          }
          this.$toast.success('Se le ha enviado un correo electrónico para que cambie su contraseña.');
          let self = this;
          window.setTimeout((obj) => (obj.$router.push({name:'Login'})), 1000, self)
        } catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
          this.stopWait();
        }
      },
      async getNewPassword() {
        if (!this.validatePassword()) return;
        const defaultToastMessage = 'Error al cambiar la contraseña.';
        const defaultConsoleMessage = 'getNewPassword error';
        try {
          this.awaitingResponse = true;
          const request = this.request;
          const response = await this.$store.dispatch('recoverPassword', {request});
          if (response === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            this.stopWait();
            return;
          }
          this.$toast.success('Su contraseña fue cambiada exitosamente.');
          let self = this;
          window.setTimeout((obj) => (obj.$router.push({name:'Login'})), 1000, self)
        } catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
          this.stopWait();
        }
      },
      validatePassword() {
        if (this.newPassword !== this.repeatPassword) {
          this.$toast.error('Las contraseñas no coinciden');
          return false;
        }
        return true;
      },
      switchAll() {
        const newValue = !this.show.all;
        for (const name in this.show) this.show[name] = newValue;
      },
      stopWait() {
        var self = this;
        window.setTimeout((obj) => { obj.awaitingResponse = false; }, 500, self);
      },
    },
  };
</script>

<style scoped>
  .cambiarPage {}
  .cambiarTitle {
    margin: 30px;
    text-align: center;
  }
  .formTitle {
    margin: 20px;
    padding-top: 30px;
  }
</style>